<template>
    <div>

        <!-- Statistieken -->
        <div class="d-flex align-items-start">
            <h2>
                <i class="fa fa-bar-chart-o"></i>
            </h2>
            <div class="w-100">
                <h2>
                    Omzet
                </h2>
            </div>
            <div class="ms-auto mt-2">
                <button v-on:click="updateComponentVisability(componentId)" class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#generalStatistics" aria-expanded="true" aria-controls="generalStatistics">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <div v-if="loading">
            <div class="loading-spinner"><i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></div>
        </div>

        <div class="fade-in" :class="{ 'loaded': ! loading }">

            <div class="collapse" :class="{'show': componentIsVisable}" id="generalStatistics">
                <div class="d-flex flex-column flex-sm-row">
                    <div class="d-flex gap-4 gap-sm-0 w-100 mb-4 mt-sm-0">
                        <p class="mb-0 text-md text-lightgrey fw-medium">
                            {{ this.data.monthName }}
                        </p>
                        <div class="ms-4 d-flex align-items-center gap-4">
                            <span @click="setPrevMonth()" role="button">
                                <i class="fa fa-chevron-left"></i>
                            </span>
                            <span @click="setNextMonth()" role="button">
                                <i class="fa fa-chevron-right"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="d-sm-flex d-xl-block gap-3 gap-md-5 mt-2 mb-3 mt-sm-3 mb-sm-4 my-xl-0 finance-stats">
                    <div class="total-turnover d-flex align-items-start flex-column flex-lg-row flex-xl-column flex-xxl-row gap-2 gap-lg-4 gap-xl-2 gap-xxl-3">
                        <div class="d-flex align-items-end gap-2 mb-2">
                            <span class="round-icon round-md bg-light me-2 me-xl-0"
                                  style="width: 33px; height: 33px;">
                                <i class="fa fa-euro"></i>
                            </span>
                            <div>
                                <p class="label mb-0 text-sm fw-medium">
                                    Totale omzet
                                </p>
                                <h3 class="number" v-html="this.data.totalRevenue"></h3>
                            </div>
                            <span class="percent text-sm fw-semibold"
                                  :class="{ 'text-success': this.data.totalOffersRevenueLastYearPercentage >= 0, 'text-danger': this.data.totalOffersRevenueLastYearPercentage < 0 }"
                            >
                            {{ this.data.totalOffersRevenueLastYearPercentage }}%
                            </span>
                            <span class="comparison text-sm fw-semibold">
                                t.o.v ‘{{ this.data.lastYear }}
                            </span>
                        </div>
                        <div style="width:100% !important; padding-left:75px;">
                            <div class="chart">
                                <Pie
                                    :chart-options="chartOptions"
                                    :chart-data="chartData"
                                    :chart-id="chartId"
                                    :dataset-id-key="datasetIdKey"
                                    :plugins="plugins"
                                    :css-classes="cssClasses"
                                    :styles="styles"
                                    :width="width"
                                    :height="height"
                                />
                            </div>
                        </div>
                    </div>

                </div>
                <div class="d-sm-flex d-xl-block gap-5 mt-3">
                    <div class="d-flex gap-5">
                        <div>
                            <h4 class="mb-2">
                                Omzetten per entiteit
                            </h4>
                            <ul class="grid-list text-sm fw-medium">
                                <li><span class="styling-a">&nbsp;</span> Offertes</li>
                                <li><span class="round-icon round-md bg-light">{{ this.data.totalOffers }}</span></li>
                                <li class="text-end">&euro; {{ this.data.totalOffersRevenue }}</li>
                                <li><span class="styling-b">&nbsp;</span> Project offertes</li>
                                <li><span class="round-icon round-md bg-light">{{ this.data.totalOfferProjects }}</span></li>
                                <li class="text-end">&euro; {{ this.data.totalOfferProjectsRevenue }}</li>
                                <li><span class="styling-c">&nbsp;</span> Webshoporders</li>
                                <li><span class="round-icon round-md bg-light">{{ this.data.totalWebshopOrders }}</span></li>
                                <li class="text-end">&euro; {{ this.data.totalWebshopRevenue }}</li>
                                <li><span class="styling-d">&nbsp;</span> Betaalverzoeken</li>
                                <li><span class="round-icon round-md bg-light">{{ this.data.totalPaymentRequests }}</span></li>
                                <li class="text-end">&euro; {{ this.data.totalPaymentRequestRevenue }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale
} from 'chart.js'

import { Pie } from 'vue-chartjs'
import {useComponentVisibility} from "../../composables/useComponentVisibility";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
        name: 'general-statistics',
        components: { Pie },
        props: {
            chartId: {
                type: String,
                default: 'pie-chart'
            },
            datasetIdKey: {
                type: String,
                default: 'label'
            },
            width: {
                type: Number,
                default: 150
            },
            height: {
                type: Number,
                default: 150
            },
            cssClasses: {
                default: '',
                type: String
            },
            styles: {
                type: Object,
                default: () => {}
            },
            plugins: {
                type: Array,
                default: () => []
            },
            isVisible: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                data: {
                    monthName: '',
                    month: '',
                    year: '',
                    pagination: [{
                        next: {
                            month: '',
                            year: '',
                        },
                        prev: {
                            month: '',
                            year: '',
                        }
                    }],
                    lastYear: '',
                    totalRevenue: '',
                    totalOffersRevenue: '',
                    totalOffersRevenueNumber: '',
                    totalOfferProjectsRevenue: '',
                    totalOfferProjectsRevenueNumber: '',
                    totalWebshopRevenue: '',
                    totalWebshopRevenueNumber: '',
                    totalPaymentRequestRevenue: '',
                    totalPaymentRequestRevenueNumber: '',

                    myOffersRevenue: ',',
                    myOffersPercentage: '',
                    totalMyRevenue: '',
                    totalMyRevenuePercentage: '',

                    totalOffersRevenueLastYear: '',
                    totalOffersRevenueLastYearPercentage: '',

                    totalOffers: '',
                    totalOfferProjects: '',
                    totalWebshopOrders: '',
                    totalPaymentRequests: '',
                    bestSellingProducts: [{
                        key: {
                            title: '',
                            total_amount: '',
                        }
                    }],
                },

                chartData: {},
                chartOptions: {},

                componentId: 'general-statistics-component',
                componentIsVisable: this.isVisible,
                componentVisibility: useComponentVisibility(),
                loading: true,
            }
        },
        computed: {},
        watch: {},
        methods: {
            updateComponentVisability(component_id) {
                // Toggle the visibility state
                this.componentIsVisable = !this.componentIsVisable;
                axios.get('api/update-component-visability', {
                    params: {
                        component_id: component_id,
                        is_visable: this.componentIsVisable
                    }
                });

                if (this.componentIsVisable) {
                    this.loading = true;
                    this.getGeneralStatistics();
                }
            },
            getGeneralStatistics() {
                axios.get('api/general-statistics?year='+this.data.year+'&month='+this.data.month)
                    .then(response => {
                        this.data = response.data;

                        this.componentId = response.data.componentId;
                        this.buildPie();

                        this.loading = false;
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            setPrevMonth() {
                this.loading = true;
                this.data.year = this.data.pagination.prev.year;
                this.data.month = this.data.pagination.prev.month;
                this.getGeneralStatistics();
            },
            setNextMonth() {
                this.loading = true;
                this.data.year = this.data.pagination.next.year;
                this.data.month = this.data.pagination.next.month;
                this.getGeneralStatistics();
            },
            buildPie() {
                this.chartData = {
                    datasets: [
                        {
                            data: [this.data.totalOffersRevenueNumber, this.data.totalOfferProjectsRevenueNumber, this.data.totalWebshopRevenueNumber, this.data.totalPaymentRequestRevenueNumber],
                            backgroundColor: ['#dc354f', '#32b8d6', '#34e479', '#d7ea34']
                        }
                    ]
                };
                this.chartOptions = {
                    responsive: true,
                    maintainAspectRatio: true,
                    autoPadding: true,
                };
            },
        },
        mounted() {
            if(this.isVisible) {
                this.getGeneralStatistics();
                this.canvas = document.getElementById('pieChart');
                this.buildPie();
            } else {
                this.loading = false;
            }
        },
        created() { },
    }
</script>

<style scoped>
    li span.styling-a {
        padding-left:10px;
        background: #dc354f;
    }
    li span.styling-b {
        padding-left:10px;
        background: #32b8d6;
    }
    li span.styling-c {
        padding-left:10px;
        background: #34e479;
    }
    li span.styling-d {
        padding-left:10px;
        background: #d7ea34;
    }
</style>
